export default __webpack_public_path__ + "static/Entenda0029-0d267bc7cf4463c9a7cd3786311b812a.jpg";